import { apiSlice } from "./apiSlice"
import { apiRoutes } from "../../config/api"

export const processService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllDeviceOfUser: builder.query({
            query: (params: any) => {
                const {userId, roleName, roleId} = params;
              return {
              url: `${apiRoutes.USER_DEVICE}/${userId}`,
              params: {
                userId,
                ...(roleName && { roleName }), // Include roleName if provided (for platform admin detection)
                ...(roleId && { roleId }) // Include roleId if provided
              },
              method: "GET",
            }},
          }),

        getDeviceStatus:builder.query({
          query: (params:any) => {
            const {userId, roleName, roleId} = params;
            return {
              url: `${apiRoutes.DEVICE_STATUS}/${userId}`,
              params: {
                userId,
                ...(roleName && { roleName }), // Include roleName if provided (for platform admin detection)
                ...(roleId && { roleId }) // Include roleId if provided
              },
              method:'GET',
            }
          }
        }),

        getDeviceStatusByMac:builder.query({
          query:(params:any) => {
            const {macDevice} = params;
            return {
              url: `${apiRoutes.DEVICE_STATUS_BY_MAC}/${macDevice}`,
              params: params,
              method: "GET"
            }
          }
        })
    })
})

export const {
            useGetAllDeviceOfUserQuery,
            useGetDeviceStatusQuery,
            useGetDeviceStatusByMacQuery 
} = processService